module.exports = __webpack_public_path__ + "img/home-person.4c88c2eb.png";